import { useId } from "react";
import { motion, useSpring, useTransform } from "framer-motion";

const LEFT = "20,24 27,17 35,17 35,83 20,83";
const RIGHT = "65,17 80,17 80,76 73,83 65,83";

export const HMark = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden>
    <polygon points={LEFT} fill="#F2EFE8" />
    <polygon points={RIGHT} fill="#F2EFE8" />
    <rect x="35" y="48.5" width="30" height="3" fill="#B89B62" />
    <rect x="46.5" y="46.5" width="7" height="7" transform="rotate(45 50 50)" fill="#B89B62" />
  </svg>
);

const Pillars = ({ tone }) => {
  const id = useId().replace(/:/g, "");
  const shadow = tone === "shadow";
  return (
    <svg viewBox="0 0 100 100" className="h-full w-full" aria-hidden>
      <defs>
        <linearGradient id={`m${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#5b564d" />
          <stop offset="38%" stopColor="#1c1b19" />
          <stop offset="62%" stopColor="#2f2c27" />
          <stop offset="100%" stopColor="#0d0d0d" />
        </linearGradient>
      </defs>
      {[LEFT, RIGHT].map((pts) => (
        <polygon
          key={pts}
          points={pts}
          fill={shadow ? "#000" : `url(#m${id})`}
          opacity={shadow ? 0.7 : 1}
          stroke={shadow ? "none" : "rgba(242,239,232,0.35)"}
          strokeWidth="0.35"
        />
      ))}
    </svg>
  );
};

const Bar = () => (
  <svg viewBox="0 0 100 100" className="h-full w-full" aria-hidden>
    <rect x="35" y="49.3" width="30" height="1.4" fill="#B89B62" />
    <rect x="47.5" y="47.5" width="5" height="5" transform="rotate(45 50 50)" fill="none" stroke="#D4B87C" strokeWidth="0.6" />
  </svg>
);

const layer = (z) => ({ transform: `translateZ(${z}px)` });

export const Monogram3D = ({ mx, my }) => {
  const spring = { stiffness: 70, damping: 18, mass: 0.6 };
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [16, -16]), spring);
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-22, 22]), spring);
  return (
    <div className="relative aspect-square w-full" style={{ perspective: "1100px" }} data-testid="hero-monogram">
      <motion.div className="absolute inset-0" style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }}>
        <div className="absolute inset-[6%] border border-line" style={layer(-70)} />
        <div
          className="absolute inset-[10%] rounded-full"
          style={{ ...layer(-90), background: "radial-gradient(circle at 50% 45%, rgba(184,155,98,0.22), rgba(184,155,98,0.04) 45%, transparent 68%)" }}
        />
        <div className="absolute inset-[14%]" style={layer(-24)}><Pillars tone="shadow" /></div>
        <div className="absolute inset-[14%]" style={layer(24)}><Pillars tone="metal" /></div>
        <div className="absolute inset-[14%]" style={layer(70)}><Bar /></div>
      </motion.div>
    </div>
  );
};
